import React, { useEffect, useRef } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import loginFormData from "./data/LoginForm.data";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ToastService from "../../services/toastService/ToastService";
import { authentication } from "../../app/slice/authSlice";
import { useUserLoginMutation } from "../../app/services/login/authApi";
import { saveData } from "../../utils/LocalStorage/LocalStorageManager";

const LoginForm = (props) => {
  const loginFromRef = useRef();
  const { isLogedin } = useSelector((state) => state.auth)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Declare admin login API
  const [login, { isLoading: loginLoading, isSuccess: loginSuccess, data: authData }] = useUserLoginMutation();

  useEffect(() => {
    if (!loginLoading && loginSuccess && authData) {
      if (authData.isAuthenticated === false) {
        ToastService.error(authData.message);
      } else if (authData.isAuthenticated === true) {
        ToastService.success("You are login successfully", "Success");
        dispatch(authentication(authData));
        saveData("roleId", authData.roleId);
      }
    }
  }, [loginLoading, loginSuccess, authData]);

  // Effect to handle navigation based on the authentication
  useEffect(() => {
    if (isLogedin) {
      navigate(`/`);
    }
  }, [isLogedin])


  const handleLogin = () => {
    // Retrieve form data
    const authData = loginFromRef.current?.getFormData();

    // Check if form data exists
    if (!authData) return;

    // Create the request object
    const request = {
      userName: authData.emailAddress,
      password: authData.password,
    };

    // Proceed with the login if form data exists
    login(request);
  };

  return (
    <div className="login-form-section">
      {/* <h2>Login</h2> */}
      <FormCreator
        ref={loginFromRef}
        {...loginFormData}
      ></FormCreator>
      <div className="flex items-center forgot-pass-sec justify-between">
        <div className="remember-me-sec">
          <input
            id="remember-me"
            name="remember-me"
            type="checkbox"
            className="h-4 w-4 text-[#F93549] focus:ring-[#4a97c9] rounded"
          />
          <label
            htmlFor="remember-me"
            className="ml-2 block text-sm text-gray-900"
          >
            {" "}
            Remember me{" "}
          </label>
        </div>

        <div className="text-sm">
          <Link
            to="/forgetPassword"
            style={{ pointerEvents: "none", color: "gray", cursor: "not-allowed", opacity: 0.6 }}
            onClick={(e) => e.preventDefault()}
            className="font-medium text-[#329a03] hover:text-[#297407]"
          >
            Forgot your password?
          </Link>
        </div>
      </div>
      <div className="button-part">
        {loginLoading ?
          <Buttons
            buttonTypeClassName="btn success-btn"
            buttonText="Login"
            isLoading={loginLoading}
          />
          :
          <Buttons
            buttonTypeClassName="btn success-btn"
            buttonText="Login"
            onClick={handleLogin}
          // isLoading={loginLoading}
          />
        }
      </div>
    </div>
  );
};

export default LoginForm;
